<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <b-img fluid :src="sideImg" />
        </b-link>

        <b-card-title class="mb-1">
          ยินดีต้อนรับเข้าสู่ พร้อมสั่ง.com !
        </b-card-title>
        <b-card-text class="mb-2">
          กรุณากรอกรหัสผ่านใหม่
        </b-card-text>

        <!-- form -->
        <validation-observer ref="loginForm" #default="{invalid}">
          <b-form class="auth-login-form mt-2" @submit.prevent="login">
            <!-- <b-form-group label="เบอร์โทรศัพท์/ อีเมล" label-for="username">
              <validation-provider
                #default="{ errors }"
                name="Phone/ Email"
                vid="username"
                rules="required"
              >
                <b-form-input
                  id="username"
                  v-model="username"
                  :state="errors.length > 0 ? false : null"
                  autofocus
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group> -->

            <!-- password -->
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="login-password">รหัสผ่านใหม่</label>
                <!-- <b-link :to="{name:'auth-forgot-password'}">
                  <small>ลืมรหัสผ่าน ?</small>
                </b-link> -->
                <!-- <b-link :to="{ name: 'auth-register-phone' }">
                  <span>&nbsp;สมัครใหม่</span>
                </b-link> -->
              </div>
              <validation-provider
                #default="{ errors }"
                name="Password"
                vid="password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="login-password"
                    v-model="password"
                    :state="errors.length > 0 ? false : null"
                    class="form-control-merge"
                    :type="passwordFieldType"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="login-password">ยืนยันรหัสผ่านใหม่</label>
                <!-- <b-link :to="{name:'auth-forgot-password'}">
                  <small>ลืมรหัสผ่าน ?</small>
                </b-link> -->
                <!-- <b-link :to="{ name: 'auth-register-phone' }">
                  <span>&nbsp;สมัครใหม่</span>
                </b-link> -->
              </div>
              <validation-provider
                #default="{ errors }"
                name="Password"
                vid="password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="login-password"
                    v-model="newpassword"
                    :state="errors.length > 0 ? false : null"
                    class="form-control-merge"
                    :type="passwordFieldType"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="login-password">ยืนยันรหัสผ่านใหม่</label>
              </div>
              <validation-provider
                #default="{ errors }"
                name="Password"
                vid="password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="login-password"
                    v-model="password"
                    :state="errors.length > 0 ? false : null"
                    class="form-control-merge"
                    :type="passwordFieldType"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group> -->

            <!-- submit button -->
            <p style="color: red;" v-if="isError">{{ errorMsg }}</p>
            <b-button variant="primary" type="submit" block :disabled="invalid">
              ยืนยัน
            </b-button>
            <div style="justify-content: center; display: flex;" class="mt-1">
              <span
                >คุณยังไม่มีบัญชีใช้งาน?<b-link
                  :to="{ name: 'auth-register-phone' }"
                  style="color: #0059de;"
                >
                  <span>&nbsp;สร้างบัญชีใหม่</span>
                </b-link></span
              >
            </div>
          </b-form>
        </validation-observer>

        <!-- <b-card-text class="text-center mt-2">
          <span>ไม่มีบัญชีผู้ใช้งาน? </span>
          <b-link :to="{name:'auth-register-phone'}">
            <span>&nbsp;สมัครใหม่</span>
          </b-link>
        </b-card-text> -->
      </b-card>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCard,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  VBTooltip,
} from "bootstrap-vue";
import { required } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";
import { onUnmounted } from "@vue/composition-api";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";
import authenStoreModule from "./authenStoreModule";
import { getUserData } from "@/auth/utils";
import router from "@/router";

export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCard,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: "",
      username: "",
      password: "",
      newpassword: "",
      rememberMe: false,
      sideImg: require("@/assets/images/logo/logo.png"),
      // validation rules
      required,
      isError: false,
      errorMsg: "",
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  setup() {
    // Register module
    if (!store.hasModule("authen"))
      store.registerModule("authen", authenStoreModule);
    // // UnRegister on leave
    // onUnmounted(() => {
    //   if (store.hasModule('authen')) store.unregisterModule('authen')
    // })

    return {};
  },
  methods: {
    login() {
      this.$refs.loginForm.validate().then((success) => {
        if (success) {
          if (this.newpassword == this.password) {
            const userModels = {
              phone: router.currentRoute.params.phone,
              code: router.currentRoute.params.otp,
              rememberMe: true,
            };

            store
              .dispatch("authen/loginSms", userModels)
              .then((response) => {
                if (response.status === 200) {
                  const userData = {
                    shopId: response.data.data.shopId,
                    shopName: response.data.data.shopName,
                    username: response.data.data.name,
                    fullName: response.data.data.name,
                    phone: response.data.data.phone,
                    email: response.data.data.email,
                    contactId: response.data.data.contactId,
                    contactType: response.data.data.contactType,
                    avatar: response.data.data.avatar,
                    token: response.data.data.token,
                    refreshToken: response.data.data.refreshToken,
                    refreshTokenExpiryTime:
                      response.data.data.refreshTokenExpiryTime,
                    // theme ACL
                    role: "admin",
                    ability: [
                      {
                        action: "manage",
                        subject: "all",
                      },
                    ],
                  };

                  console.log("userData", userData);

                  useJwt.setToken(userData.token);
                  useJwt.setRefreshToken(userData.refreshToken);

                  localStorage.setItem("userData", JSON.stringify(userData));

                  this.$ability.update(userData.ability);

                  this.isError = false;
                  const userModel = {
                    userName: router.currentRoute.params.username,
                    password: btoa(this.password),
                    newPassword: btoa(this.password),
                    token: router.currentRoute.params.token,
                  };

                  store
                    .dispatch("authen/newPassword", userModel)
                    .then((response) => {
                      if (response.status === 200) {
                        this.$router
                          .replace(getHomeRouteForLoggedInUser(userData.role))
                          .then(() => {
                            this.$toast({
                              component: ToastificationContent,
                              position: "top-right",
                              props: {
                                title: `Welcome ${userData.fullName}`,
                                icon: "CoffeeIcon",
                                variant: "success",
                                text: "You have successfully logged in!",
                              },
                            });
                          });
                      }
                    })
                    .catch((error) => {
                      // this.$refs.loginForm.setErrors(error.response.data.error);
                    });
                }
              })
              .catch((error) => {
                // this.$refs.loginForm.setErrors(error.response.data.error);
              });
          } else {
            this.isError = true;
            this.errorMsg = "กรุณากรอกรหัสให้ถูกต้อง";
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
